import { graph, layout } from "../utils/globals";
import {
  BufferAttribute,
  BufferGeometry,
  Color,
  LineBasicMaterial,
  LineSegments,
  ShaderMaterial,
  VSMShadowMap,
} from "three";

import vs from "../glsl/edges.vert";
import fs from "../glsl/edges.frag";
export default class Edges extends LineSegments {
  constructor() {
    super(
      new BufferGeometry(),
      // new LineBasicMaterial({
      //   color: 0xeaeaea,
      // })
      new ShaderMaterial({
        uniforms: {
          color: { value: new Color(0xeaeaea) },
          opacity: { value: 0 },
        },
        vertexShader: vs,
        fragmentShader: fs,
        transparent: true,
        depthWrite: false,
      })
    );
    this.visible = false;
    this.update();
    this.renderOrder = 10;
    this.geometry.computeBoundingSphere();
    this.geometry.boundingSphere.radius = 100000;
  }

  update(zoomRatio) {
    this.material.uniforms.opacity.value = zoomRatio;

    let vertices = [];
    let alphas = [];
    let i = 0;
    graph.forEachLink(function (link) {
      let l = layout.getLinkPosition(link.id);
      if (l == undefined) return;
      let p = l.from;
      vertices.push(p.x, p.y, -1);
      p = l.to;
      vertices.push(p.x, p.y, -1);
      let a = link.alpha;
      alphas.push(a, a);
    });

    this.geometry.setAttribute(
      "position",
      new BufferAttribute(new Float32Array(vertices), 3)
    );
    this.geometry.setAttribute(
      "alpha",
      new BufferAttribute(new Float32Array(alphas), 1)
    );
    this.geometry.needsUpdate = true;
  }
}
